<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item label="客户名称:">
          <el-select v-model="filters.companyId" filterable clearable placeholder="请选择" @change="companyChange">
            <el-option
                    v-for="item in companies" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域:">
          <el-select v-model="filters.groupId" clearable placeholder="请选择" @change="groupChange">
            <el-option
                    v-for="item in groups" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称:" >
          <el-select v-model="filters.deviceId" clearable placeholder="请选择">
            <el-option
                    v-for="item in devices"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
                  v-model="filters.date"
                  type="date"
                  placeholder="选择时间"
                  align="right" style="width:130px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="!filters.date" v-on:click="search()" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="logs" border v-loading="listLoading"
              style="width: 100%;" @expand="expandChange" ref="row_table">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.lineTimeList" border highlight-current-row
                    style="width: 100%;">
            <el-table-column header-align="center" align="center" label="离线时间" :formatter="formatTime" min-width="250">
            </el-table-column>
            <el-table-column header-align="center" align="center" label="上线时间" :formatter="formatTime2" min-width="250">
            </el-table-column>
            <el-table-column header-align="center" align="center" label="离线时长" :formatter="formatDuration" min-width="250">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="deviceNo" label="设备ID" width="250">
      </el-table-column>
      <el-table-column
              header-align="center"
              align="center"
              prop="name" label="设备名称"
              min-width="150">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="offlineCount" label="离线次数" min-width="150">
      </el-table-column>
      <el-table-column header-align="center" align="center" :formatter="formatDuration2" label="总离线时长" min-width="150">
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template scope="scope">
          <el-button type="primary" size="small" :disabled="scope.row.offlineCount <= 0 || scope.row.disposed" @click="handleAdd(scope.$index, scope.row)">原因提交</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="提交原因" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <el-form-item label="设备ID" prop="deviceNo">
          <el-input v-model="addForm.deviceNo" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="事件时间" prop="eventDate">
          <el-input v-model="addForm.eventDate" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="掉线类型" prop="type">
          <el-select v-model="addForm.type" placeholder="请选择">
            <el-option
                    v-for="item in types" :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服姓名" prop="customerName">
          <el-input v-model="addForm.customerName" maxlength="5"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" rows="5" maxlength="300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  //import NProgress from 'nprogress'
  import {getCompanyList,getGroupList,getDevicesByGroupList,getDeviceLogList,getServiceLogList,addServiceLog} from '../../api/api';

  export default {
    data() {
      return {
        filters: {
          companyId: '',
          groupId: '',
          deviceId: '',
          date: moment().format('YYYY-MM-DD'),
        },
        total: 0,
        page: 1,
        listLoading: false,
        companies:[],
        groups:[],
        devices:[],
        logs:[],
        addForm:{
          deviceNo: '',
          eventDate: '',
          type: 0,
          customerName: '',
          remark: '',
        },
        addFormVisible: false,
        addFormRules: {
          customerName: [
            {required: true, message: '请输入客服姓名', trigger: 'blur'},
          ],
          remark: [
            {required: true, message: '请输入备注', trigger: 'blur'},
          ],
        },
        addLoading: false,
        types: [
          {
            id: 0,
            name:'断电'
          },
          {
            id: 1,
            name:'信号差'
          },
          {
            id: 2,
            name:'设备故障'
          }
        ]
      }
    },
    methods: {
      cleanFilter() {
        this.filters.companyId = '';
        this.filters.groupId = '';
        this.filters.deviceId = '';
        this.filters.date = moment().format('YYYY-MM-DD');
      },
      formatTime: function (row, column) {
        return moment(row.offlineTime).format('YYYY-MM-DD HH:mm:ss');
      },
      formatTime2: function (row, column) {
        if (row.onlineTime == 0) return '-';
        return moment(row.onlineTime).format('YYYY-MM-DD HH:mm:ss');
      },
      formatDuration: function (row, column) {
        var time = row.onlineTime;
        if (row.onlineTime == 0) {
          time = new Date().getTime()
        }
        var duration = time - row.offlineTime;
        var h = duration/1000/60/60;
        if (h < 1) {
          return Math.ceil(duration/1000/60) + '分钟';
        } else {
          var m = Math.ceil(((h - Math.floor(h)) * 60));
          if (m == 60) return (Math.floor(h) + 1) + '小时';
          return m == 0 ? Math.floor(h) + '小时' : Math.floor(h) + '小时' + m + '分钟';
        }
      },
      formatDuration2: function (row, column) {
        if (row.lineTimeList.length == 0) return '-';
        var duration = 0;
        for (var i=0;i<row.lineTimeList.length;i++) {
          var time = row.lineTimeList[i].onlineTime;
          if (row.lineTimeList[i].onlineTime == 0) {
            time = new Date().getTime()
          }
          var t = time - row.lineTimeList[i].offlineTime;
          duration += t;
        }

        var h = duration/1000/60/60;
        if (h < 1) {
          return Math.ceil(duration/1000/60) + '分钟';
        } else {
          var m = Math.ceil(((h - Math.floor(h)) * 60));
          if (m == 60) return (Math.floor(h) + 1) + '小时';
          return m == 0 ? Math.floor(h) + '小时' : Math.floor(h) + '小时' + m + '分钟';
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      expandChange(row, expanded) {
        this.$refs.row_table.store.states.expandRows = expanded ? [row] : [];
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;
          if (this.groups.length == 0) {
            if (this.filters.companyId)
              this.getDevicesByGroup('');
          } else {
            this.getDevicesByGroup(this.groups[0].id);
          }
          //NProgress.done();
        });
      },
      search() {
        let para = {
          page: this.page,
          pageSize: 10,
          companyId: this.filters.companyId,
          groupId: this.filters.groupId,
          deviceId: this.filters.deviceId,
          startTime: moment(this.filters.date).hours(0).minutes(0).seconds(0).valueOf(),
          endTime: moment(this.filters.date).hours(0).minutes(0).seconds(0).add('day', 1).valueOf(),
        };
        //NProgress.start();
        getDeviceLogList(para).then((res) => {
          this.logs = res.data.list;
          this.total = res.data.total;
          //NProgress.done();
        });
      },
      getDevicesByGroup(val) {
        let para = {
          groupId: val
        };
        //NProgress.start();
        getDevicesByGroupList(para).then((res) => {
          this.devices = res.data;
          //NProgress.done();
        });
      },
      companyChange: function (val) {
        this.filters.groupId = '';
        this.filters.deviceId = '';
        this.getGroups(val);
      },
      groupChange: function (val) {
        this.filters.deviceId = '';
        this.getDevicesByGroup(val);
      },
      handleAdd: function (index, row) {
        this.addFormVisible = true;
        if (this.$refs['addForm']) {
          this.$refs['addForm'].resetFields();
        }
        this.addForm = {
          deviceNo: row.deviceNo,
          eventDate: moment(this.filters.date).format('YYYY-MM-DD'),
          type: 0,
          customerName: '',
          remark: '',
        };
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              addServiceLog(para).then((res) => {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.search();
              });
            });
          }
        });
      },

    },
    mounted() {
      this.getCompanies();
      this.search();
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DeviceStatus.vue?30d1591e